<template>
  <div class="login">
    <div class="bg-transparent w-100 vertical-center">
        <div class="row">
            <div class="col-md-3"></div>
            <div class="col-md-6">
                <div class="bg-black rounded p-3">
                    <div class="btn bg-black text-center rounded mt-2">
                        <img :src="require(`@/assets/app/logo.jpg`)" alt="Kraken" width="300" height="300" class="rounded">
                    </div>
                    <div class="fw-bold fs-1 w-100 gradient-text" style="letter-spacing: 7px;">Kraken</div>
                    <hr class="bg-primary mt-4">
                    <form v-if="service_mode != null" @submit.prevent="login">
                        <input :disabled='isDisabled' required  v-model="username" id="appUsername" type="text" class="btn bg-black border-bottom border-primary text-white fw-light border-0 mt-2 fs-3" placeholder="Username" style="color: White; text-align: center; width: 70%; cursor: text;"/>
                        <input v-if="service_mode=='public'" :disabled='isDisabled' required  v-model="customer" id="appCustomer" type="text" class="btn bg-black border-bottom border-primary text-white fw-light border-0 mt-4 fs-3" placeholder="Customer" style="color: White; text-align: center; width: 70%; cursor: text;"/>
                        <input :disabled='isDisabled' required  v-model="password" autocomplete="" id="appPassword" type="password" class="btn bg-black border-bottom border-primary text-white fw-light border-0 mt-4 fs-3" placeholder="Password" style="color: White; text-align: center; width: 70%; cursor: text"/>
                        <button :disabled='isDisabled' class="btn btn-kraken btn-lg btn-block mt-3 mb-5 fs-5" style="color: White; text-align: center; width: 70%" type="submit">
                            <i class="fa-solid fa-xl" :class="{'fa-right-to-bracket': !trying , 'fa-refresh fa-spin': trying}"></i>
                        </button>
                    </form>
                    <div v-if="service_mode == null">
                        <div class="gradient-text fs-2">
                            <i class="fa-solid fa-refresh fa-spin"></i>
                        </div>
                    </div>

                </div>
            </div>
        </div>
    </div>
  </div>
</template>

<script>
import axios from "axios";

export default {
  name: 'Login',
  delimiters : ['[[', ']]'],
  data() {
      return {
        site: `${window.location.protocol}//${window.location.host}/kraken`,
        service_mode: null,
        username: null,
        customer: null,
        password: null,
        trying: false,
        isDisabled: false,
        error: false,
        errorMessage: ""
      }
  },
  methods: {
    login(){
        this.error = false
        this.trying = true
        this.isDisabled = true

        // Verification
        if (!this.customer && this.service_mode =='PUBLIC'){
            alert('Invalid customer.')
            return 
        }
        if (this.service_mode == 'PRIVATE'){
            this.customer = null
        }
        const params = {username: this.username, secret: this.password, customer: this.customer, service_mode: this.service_mode}
        const dest = this.site + '/suite/main/login'
        axios
            .post(dest, {params})
            .then(rx => {
                this.isDisabled = false
                this.trying = false
                this.$router.push("/home")
            })
            .catch(error => {
                this.isDisabled = false
                try {
                    alert(error.response.data.error)
                } catch (error) {
                    alert("Failed connection with server, check your connection.")
                }
                this.trying = false
            });
    },
    getMode(){
        const params = {permit: 'KR-2025-WS'}
        const dest = this.site + '/suite/main/mode'
        axios
            .get(dest, {params})
            .then(rx => {
                this.service_mode = rx.data.wsmode
            })
            .catch(error => {
                try {
                    alert(error.response.data.error)
                } catch (error) {
                    alert("Failed connection with server, check your connection.")
                }
            });
    }
  },
  mounted: function(){
    if (process.env.NODE_ENV == 'development'){
        this.site = process.env.VUE_APP_SERVICE_URL
    }
    this.getMode()
    localStorage.clear();
  }
}
</script>

<style scoped>

    .login{
        width: 100%;
        height: 100%;
        margin: 0px;
        padding: 0px;
        overflow: hidden;
        overflow-y: hidden;
    }

    .vertical-center {
        margin: 0;
        position: absolute;
        top: 50%;
        -ms-transform: translateY(-50%);
        transform: translateY(-50%);
    }

    .btn-kraken{
        background-color: rgb(20, 63, 162);
        color: white;
        transition-duration: 0.5s;
    }
    .btn-kraken:hover{
        background-color: rgb(0, 17, 39);
        color: rgb(0, 158, 249);
    }
    
    .gradient-text{
        background-image: linear-gradient(rgb(57, 198, 249), rgb(0, 34, 90));
        color: transparent;
        background-clip: text;
    }
    .gradient-text:hover{
        background-image: linear-gradient(rgb(0, 34, 90), rgb(57,198,249));
        color: transparent;
        background-clip: text;
    }

</style>